export default __webpack_public_path__ + "static/media/adminUser.39537447.png";